import { Controller } from 'stimulus';

// The Record calibration sheet (calibrations/_record_sheet): Due follows
// Calibrated on by the equipment's schedule until someone types a Due of
// their own; "Recording an older certificate" hides the status after; the
// drop zone names the file chosen.
//
//   data-record-sheet-number="12" data-record-sheet-period="months"
export default class extends Controller {
  static targets = ['start', 'due', 'older', 'status', 'file', 'fileName'];

  startChanged() {
    const number = parseInt(this.data.get('number'), 10);
    const period = this.data.get('period');
    if (this.dueTouched || !number || !period || !this.startTarget.value) return;

    const due = this.advance(this.startTarget.value, number, period);
    if (due) this.dueTarget.value = due;
  }

  dueChanged() {
    this.dueTouched = true;
  }

  olderChanged() {
    this.statusTarget.classList.toggle('hidden', this.olderTarget.checked);
  }

  fileChosen() {
    const file = this.fileTarget.files[0];
    if (file) this.fileNameTarget.textContent = file.name;
  }

  // "2026-01-31" + 1 month = "2026-02-28", as Rails' Date#advance does.
  advance(iso, number, period) {
    const parts = iso.split('-').map((n) => parseInt(n, 10));
    if (parts.length !== 3 || parts.some(Number.isNaN)) return null;

    let [year, month, day] = parts;
    if (period === 'days' || period === 'weeks') {
      const date = new Date(Date.UTC(year, month - 1, day + number * (period === 'weeks' ? 7 : 1)));
      return date.toISOString().slice(0, 10);
    }

    const months = number * (period === 'years' ? 12 : 1);
    const total = (year * 12) + (month - 1) + months;
    year = Math.floor(total / 12);
    month = (total % 12) + 1;
    const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
    day = Math.min(day, lastDay);
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  }
}
